module.exports = __webpack_public_path__ + "static/img/defaultHead.963d974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultHead.jpg
// module id = piHc
// module chunks = 121